<template>
    <div class="user d-flex align-items-center justify-content-end pr-4">
        <router-link v-if="showNewBookingBtn" to="/reservation" tag="button" class="btn tertiary mr-3">New Booking</router-link>

        <notifications-bell v-if="showNotifications"></notifications-bell>

        <div class="person d-flex align-items-center pointer" @click="openAccountDetails">
            <span class="hidden-lg-down mx-3">{{ account.name }}</span>

            <i v-if="!account.avatar" class="fas fa-user-circle dark fa-2x mr-0"></i>
            <div v-else class="avatarHolder radius-circle" :style="{ 'background-image': 'url(' + account.avatar + ')' }"></div>

            <a class="pointer ml-3" @click.stop.prevent="triggerLogout">Logout</a>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Messages from './Messages'
    import NotificationsBell from './Notifications'

    export default {
        data() {
            return {
                notificationCheckerTimer: null,
            }
        },
        created() {
            this.fetchUnviewdNotificationsCount();
            this.notificationChecker();

            if (process.env.SHOW_INTERCOM === true) {
                this.$intercom.boot({
                    user_id: this.account.id,
                    account_type: this.getUserAccessType.label,
                    platform: 'Supplier',
                    parent_company: this.account.supplier.brand,
                    parent_company_id: this.account.supplier.id,
                    name: this.account.name,
                    email: this.account.email,
                });
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getUserAccessType'
            ]),
            showNewBookingBtn() {
                // Hide to viewer
                return !this.accessPermissionFilter(['viewer']);
            },
            showNotifications() {
                // Hide to viewer
                return !this.accessPermissionFilter(['viewer']);
            },
        },
        methods: {
            ...mapActions([
                'logout',
                'setSupplierAccountAsSelected',
                'openModal',
                'fetchUnviewdNotificationsCount',
                'setCheckNotificationsInterval',
            ]),
            triggerLogout() {
                this.clearAllCustomNotifications();
                this.logout();
            },
            notificationChecker() {
                let vm = this;

                this.setCheckNotificationsInterval(setInterval(function(){
                        vm.fetchUnviewdNotificationsCount();
                    }, 180000) // 3 minutes
                )
            },
            openAccountDetails() {
                let account = {
                    id: this.account.id,
                    isActive: true,
                    name: this.account.name,
                    email: this.account.email,
                    imagePhoto: this.account.avatar,
                    imagePhotoBase64:null,
                    userAccountTypeDefault:{
                        accountType:this.account.accountType,
                        accessType:this.account.accessType,
                        isDefault:true,
                        supplierId:this.account.supplierId,
                    },
                    userAccountTypes:[
                        {
                            accountType: this.account.accountType,
                            accessType: this.account.accessType,
                            defaultHomePage: this.account.defaultHomePage,
                            isDefault: true,
                            supplierId: this.account.supplierId,
                        }
                    ],
                    salesChannel: this.account.salesChannel
                };

                this.setSupplierAccountAsSelected(JSON.parse(JSON.stringify(account)));
                this.openModal('supplierAccountModal');
            }
        },
        components: {
            Messages,
            NotificationsBell
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .bar {
        .user {
            [class^="ico-"], [class*=" ico-"] {
                position: relative;
            }

            .messages {
                .write {
                    > input {
                        border: 0;
                        padding: 0;
                        margin: 0;
                    }
                }

                .number {
                    position: absolute;
                    top: 0;
                    right: -7px;
                    font-size: 0.55rem;
                    padding: 3px 3px;
                    border-radius: 0.25rem;
                }

                .box {
                    position: absolute;
                    top: 43px;
                    right: -100%;
                    z-index: 30;
                    width: 25rem;

                    ul {
                        > li {
                            display: flex;
                            align-items: center;
                            color: $darker;
                            font-size: $font-size-small;
                            cursor: pointer;
                        }
                    }
                }
            }

            .person {
                > span {
                    font-size: $font-size-small;
                    margin: 0 0.5rem 0 1rem;
                }

                .avatarHolder{
                    width: 30px;
                    height: 30px;
                    background-position: center;
                    background-size: cover;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// User.vue?5f4cfc29